import React from 'react';
import './Button.scss';

export default function Button({ children, type, className, onClick, href, onMouseEnter, onMouseLeave}) {
    const classes = `btn ${className}` + (type ? ` ${type}` : '');

    return href ? (
        <a href={href} className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {children}
        </a>
    ) : (
        <button className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {children}
        </button>
    );
}
